import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState = {
  loading: false,
};

export const appSlice = createSlice({
    name: "app",
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        loading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const { loading } = appSlice.actions;

export default appSlice.reducer;
